import { styled } from '@vw-marketing/us-components';

export const StyledZipInputContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

export const StyledInputWrapper = styled.div`
  position: relative;
  width: 100%;

  /* Hide the error icon specifically */
  [class*="StyledAdditionalInfo"] svg,
  [class*="StyledDisplayTag"] svg {
    display: none !important;
  }

  /* Keep location button visible */
  button svg {
    display: block !important;
  }
`;

export const StyledLocationButton = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  z-index: 10;

  &:hover:not(:disabled) {
    opacity: 0.7;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.content.active};
    outline-offset: 2px;
    border-radius: 4px;
  }

  svg {
    width: 24px;
    height: 24px;
    color: ${({ theme }) => theme.colors.content.active};
  }
`;